"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnConsentExpiry = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * Enum of options available for behavior to exhibit when the user's consent has expired
 */
exports.OnConsentExpiry = (0, type_utils_1.makeEnum)({
    /** Reprompts the user to change or confirm their selection */
    Prompt: 'Prompt',
    /** Resets the user's consent and reprompts them */
    ResetAll: 'ResetAll',
    /** Resets the user's opted-in purposes and reprompts them */
    ResetOptIns: 'ResetOptIns',
});
//# sourceMappingURL=consentExpiry.js.map